import { render, staticRenderFns } from "./QuestionAlternative.vue?vue&type=template&id=394e0c3c&"
import script from "./QuestionAlternative.vue?vue&type=script&lang=js&"
export * from "./QuestionAlternative.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAlternative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports